import AuthModel from '../../models/Auth';

const LOG_IN = 'LOG_IN';
const LOG_OUT = 'LOG_OUT';
const GET_AUTH_PROFILE = 'GET_AUTH_PROFILE';

/**
 * 登录
 * @param {string} username 用户名
 * @param {string} password 密码
 */
async function login({ username, password }) {
  const payload = await new AuthModel().login({ username, password });
  return {
    type: LOG_IN,
    payload
  }
}

/**
 * 退出登录
 */
async function logout() {
  const payload = await new AuthModel().logout();
  return {
    type: LOG_OUT,
    payload
  };
}

/**
 * 获取用户信息
 */
async function getAuthProfile() {
  const payload = await new AuthModel().profile();
  return {
    type: GET_AUTH_PROFILE,
    payload
  };
}

const ACTION_TYPES = {
  LOG_IN,
  LOG_OUT,
  GET_AUTH_PROFILE,
};

const ACTION = {
  login,
  logout,
  getAuthProfile,
};

const Auth = {
  ACTION_TYPES,
  ACTION
}

export default Auth;